@if (chatWindow.mode() === 'fullscreen') {
  <app-chat-session-history
    layout="sidebar"
    (newChat)="newChat()"
    (selectSession)="openSession($event)" />
}

<div #chatMain class="chat-main" (scroll)="onScroll()">
  <app-chat-header
    [session]="conversation.activeSession()"
    [fullscreen]="chatWindow.mode() === 'fullscreen'"
    (showOverview)="showOverview()"
    (newChat)="newChat()"
    (deleteSession)="requestDeleteSession($event)"
    (enterFullscreen)="chatWindow.setMode('fullscreen')" />

  <main class="content" [class.content--empty]="isStartView()">
    @if (conversation.error()) {
      <cui-empty-state
        title="Chat unavailable"
        [description]="conversation.error()"
        icon="forum"
        variant="transparent" />
    } @else if (isStartView()) {
      <div class="start-view" [class.start-view--history]="showOverviewHistory()">
        @if (chatWindow.mode() === 'sidebar' && !conversation.activeSession()) {
          <app-chat-session-history (selectSession)="openSession($event)" />
        }
        <div class="chat-greeting">
          <h2>What can I help you with?</h2>
          <p>Start typing below to begin a new chat.</p>
        </div>
      </div>
    } @else {
      <app-chat-history
        [currentAgentMsg]="conversation.currentAgentMsg()"
        [messages]="conversation.messages()" />
    }
  </main>

  <div class="composer-anchor">
    <div class="composer">
      @if (showScrollButton() && !conversation.isOverview()) {
        <div class="scroll-button">
          <button
            cuiButton
            square
            size="small"
            variant="grey"
            type="button"
            aria-label="Scroll to bottom"
            (click)="scrollToBottom()">
            <span class="material-symbols-outlined" aria-hidden="true">arrow_downward</span>
          </button>
        </div>
      }
      <app-chat-input (focusChange)="inputFocused.set($event)" (send)="sendMessage($event)">
        <app-chat-expert-picker
          chatInputEnd
          [experts]="conversation.experts()"
          [selectedExpert]="conversation.selectedExpert()"
          (selectExpert)="selectExpert($event)" />
      </app-chat-input>
    </div>
  </div>
</div>
@if (draggingFiles()) {
  <div class="file-drop-overlay" aria-hidden="true">
    <span class="material-symbols-outlined">upload_file</span>
    <h1>Drop files to attach</h1>
  </div>
}
